// @ts-generator-hash: f9a95eb33f4bce9def8f8ef9231ee9c20e3aea641ee7b8f34d84388a4f58a344
// Generation date: 9/22/2026 11:09:52 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.PermissionType
export enum PermissionType {
  View = 0,
  Delete = 1,
  Edit = 2,
  EditDates = 3,
  EditStartDate = 4,
  EditEndDate = 5,
  EditCompletionDate = 6,
  Upload = 7,
  Comment = 9,
  EditRequest = 10,
  EditResponse = 11,
  Resubmit = 12,
}
